// **** import modules ****
import $ from "jquery";


// **** process ****
export default {
	viewSwitch: 100,
	
	init() {
		this.$element = $("#scroll_to_pagetop");
		
		if(this.$element.length) {
			const { $window } = window.app.components;
			$window.on("scroll", e => {
				clearTimeout(this._timer);
				this._timer = setTimeout(() => {
					const isVisible = $window.scrollTop() > this.viewSwitch;
					this.$element.attr("data-visible", isVisible ? "1" : "0");
				}, 150);
			});
		}
		
		return this;
	}
};
